import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-daily-summary-report',
    templateUrl: './daily-summary-report.component.html',
    styleUrls: ['./daily-summary-report.component.css'],
    standalone: false
})
export class DailySummaryReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
